import React from 'react';
import Header from './pages/Header';
import Home from './pages/Home';
import About from './pages/About';
import Experiences from './pages/Experiences';
import Contacts from './pages/Contacts';

function App() {
  return (
    <div>
      <Header />
      <div data-bs-spy="scroll" data-bs-target="#navbar-main">
        <Home />
        <About />
        <Experiences />
        {/*<Portfolio />*/}
        <Contacts />
      </div>
    </div>
  );
}

export default App;